import { Box, Text } from '@chakra-ui/react'

import { DotLoader } from '../DotLoader/DotLoader'

interface CustomLoadingOverlayProps {
  message?: string
  isRow?: boolean
}

export const CustomLoadingOverlay = ({
  message,
  isRow = false,
}: CustomLoadingOverlayProps) => {
  return (
    <Box
      display="flex"
      flexDirection={isRow ? 'row' : 'column'}
      alignItems="center"
      justifyContent="center"
      backgroundColor={isRow ? 'presets.turquoise.10' : ''}
      padding="0"
    >
      {!isRow && (
        <DotLoader
          loaderHeight={!isRow ? '60px' : '10px'}
          loaderWidth={!isRow ? '0px' : '80px'}
        />
      )}
      <Text
        color="presets.turquoise.80"
        fontSize="12px"
        fontWeight="600"
        ml={isRow ? '23px' : 0}
        textAlign="center"
      >
        {message || 'Loading table data...'}
      </Text>
    </Box>
  )
}

export const NullRenderer = () => null
